/**
 * internal dependencies
 */
import { COMMON_FORM_ELEMENTS } from "../utils/pin-pool-types";
import { IPinPoolIndivdiual } from '../../../../../models/cardgroup.interface';

/**
 * Function to display the pin pool warning modal
 * 
 * @param {HTMLElement} modalElement the modal element
 * @param {string} modalMSG the modal message
 * @param {any} data optional data for the modal
 * @return void
 */
export const PinPoolModalDisplay = (modalElement: HTMLElement, modalMSG: string, modalType: string, data?: IPinPoolIndivdiual) => {
  if ( !modalElement ) return;

  const pinPoolModalClose = document.querySelector('.modal-close') as HTMLElement;
  const modalHeader = document.querySelector('.modal-title') as HTMLElement;
  const { cePinNumberInput, cePinDescriptionInput, ceSubmitButton } = COMMON_FORM_ELEMENTS;
  const deleteButton = document.querySelector('#aafp_pin-pool-delete') as HTMLButtonElement;

  modalElement.style.display = 'block';

  if ( modalMSG !== '' ) {
    modalHeader.innerText = modalMSG!;
  }

  const form = document.querySelector('#aafp_pin-pool-form') as HTMLFormElement;

  pinPoolModalClose.onclick = function() {
    modalElement.style.display = 'none';
    modalHeader.innerText = '';
    ceSubmitButton.classList.remove('aafp_display-none');
    deleteButton.classList.add('aafp_display-none');
    form.classList.remove('was-validated');
    form.reset();
  }

  // #TODO: The close function needs to be customized based on modal type.  
  // If there is data then display it.

  if ( modalType === 'remove' && data ) {
    const { validValue, description, validate } = data;

    deleteButton.classList.remove('aafp_display-none');
    cePinNumberInput.value = validValue ?? '';
    cePinNumberInput.setAttribute('disabled', 'true');
    cePinDescriptionInput.value = description ?? '';
    cePinDescriptionInput.setAttribute('disabled', 'true');
    ceSubmitButton.classList.add('aafp_display-none');
  }
};